import * as misc from '../actionCreators/miscellaneous';
import * as readerActions from '../actionCreators/readers';
import * as readersApis from '../../services/api/readers';
import { extractErrorMessage } from '../helpers';

export const doGetVersions = (payload, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    const { data } = await readersApis.GetVersions(payload);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    callBack && callBack(data?.message?.versions)
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doUpdateVersion = (payload, orgId, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    await readersApis.UpdateVersion(payload, orgId);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    callBack && callBack()
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doGetUpdateDetails = (payload, orgId, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    const { data } = await readersApis.GetUpdateDetails(payload, orgId);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(readerActions.doReadDeviceUpdateList({ updateDevices: data?.message?.devices || [] }));
    callBack && callBack()
  } catch (error) {
    dispatch(readerActions.doReadDeviceUpdateList({ updateDevices: [] }));
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

export const doGetCancelFirmwareUpdate = (payload, orgId, callBack) => async (dispatch) => {
  try {
    dispatch(misc.doDisplayLoadingBar({ isLoading: true }));
    await readersApis.CancelFirmwareUpdate(payload, orgId);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    callBack && callBack()
  } catch (error) {
    const message = extractErrorMessage(error);
    dispatch(misc.doDisplayLoadingBar({ isLoading: false }));
    dispatch(misc.doCreateNotification({ isVisible: true, message }));
  }
};

